export default {
  addOnModal: 'نافذة {{addOn}}',
  applyPromoCode: 'تطبيق رمز الخصم',
  bookExperienceAriaLabel: 'احجز {{title}}',
  bookExperiencePanel: 'لوحة حجز التجربة',
  calendarIcon: 'أيقونة التقويم',
  closeModal: 'إغلاق النافذة',
  coverImageForResource: 'صورة الغلاف لتجارب {{title}}',
  dateSelector: 'محدد التاريخ',
  decreaseAddOnAmount: 'تقليل عدد {{addOn}} المحدد',
  decreasePriceTierTickets: 'تقليل تذاكر {{priceTier}}',
  deleteReservation: 'حذف حجز {{experienceTitle}}',
  downloadFilename: 'تنزيل {{filename}}',
  editParticipantsFor: 'تعديل المشاركين في {{experienceTitle}}',
  enterFullscreen: 'الدخول إلى وضع ملء الشاشة',
  enterPromoCode: 'إدخال رمز الخصم',
  exitFullscreen: 'الخروج من وضع ملء الشاشة',
  filterBy: 'تصفية حسب {{filter}}',
  filterByDateRange: 'تصفية حسب نطاق التاريخ',
  gallery: 'المعرض',
  goBack: 'الرجوع إلى الصفحة السابقة',
  hostUserIcon: 'أيقونة المستخدم المضيف',
  hyattBanner: 'لافتة عضو World Of Hyatt الحصرية',
  hyattBannerDesc:
    'لافتة ترويجية تشير إلى المزايا والعروض الحصرية المتاحة لأعضاء برنامج ولاء World of Hyatt',
  imageOf: 'صورة لـ {{title}}',
  imageSlide: 'شريحة صورة',
  increaseAddOnAmount: 'زيادة عدد {{addOn}} المحدد',
  increasePriceTierTickets: 'زيادة تذاكر {{priceTier}}',
  interactiveMapAltText: 'خريطة تفاعلية مع {{title}} قابلة للاختيار',
  itemsInCart: '{{count}} عنصر في سلة التسوق',
  joinWaitlistAriaLabel: 'انضم إلى قائمة الانتظار لـ {{title}}',
  mediaGallery: 'دائري - معرض الوسائط',
  mediaSlides: 'شرائح الوسائط',
  moreFiltersAndExperiences: 'مزيد من المرشحات والتجارب',
  moreInformationAboutAddOn: 'مزيد من المعلومات حول {{addOn}}',
  muteVideo: 'كتم صوت الفيديو',
  nextPhoto: 'الصورة التالية',
  nextSlide: 'الشريحة التالية',
  nextWeek: 'الأسبوع التالي',
  noDescription: 'لا يوجد وصف',
  noVideoPlayback: 'لا تتوفر إمكانية تشغيل الفيديو',
  of: 'من',
  overallReviewRating: 'التقييم الإجمالي للمراجعة {{rating}} من 5',
  paginationBulletMessage: 'الانتقال إلى الشريحة',
  pauseVideo: 'إيقاف الفيديو مؤقتًا',
  photoOf: 'صورة لـ {{name}}',
  playVideo: 'تشغيل الفيديو',
  previousPhoto: 'الصورة السابقة',
  previousSlide: 'الشريحة السابقة',
  previousWeek: 'الأسبوع السابق',
  reserveName: `حجز {{name}}`,
  reserveSelectedSlot: 'حجز الموعد المحدد',
  reviewRating: 'تقييم المراجعة {{rating}} من 5',
  scheduleAgenda: 'جدول الأعمال',
  scheduleNav: 'تنقل الجدول',
  scheduleViewSelector: 'محدد عرض الجدول',
  selectedDateAriaLabel: '{{date}}، محدد',
  selectCountryCodeForPhoneNumber: 'اختر رمز الدولة لرقم الهاتف',
  selectData: `اختر {{data}}`,
  selectDate: 'اختر التاريخ',
  selectParticipants: 'اختر المشاركين',
  selectSessionTime: 'اختر وقت الجلسة',
  tapToBookExperience: 'احجز {{title}}',
  unmuteVideo: 'تشغيل صوت الفيديو',
  videoSlide: 'شريحة فيديو',
  viewFullDescription: 'عرض الوصف كاملاً',
  viewFullDetailsDescription: 'عرض وصف التفاصيل الكامل',
  viewShoppingCart: 'عرض سلة التسوق',
  zoomIn: 'تكبير',
  zoomOut: 'تصغير',
};
